import { render, staticRenderFns } from "./TaskCount.vue?vue&type=template&id=9be9df10&scoped=true&"
import script from "./TaskCount.vue?vue&type=script&lang=js&"
export * from "./TaskCount.vue?vue&type=script&lang=js&"
import style0 from "./TaskCount.vue?vue&type=style&index=0&id=9be9df10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9be9df10",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
